import { useCallback } from "react";

import { useQuery } from "hooks";
import { useAccess } from "components/Access";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function useAddUserButton() {
  const queryFactory = useCallback(() => {
    const query = `
            query practiceSubscription {
              practice {
                subscriptions {
                  edges {
                    node {
                      id
                    }
                  }
                }
              }
            }`;

    const resolver = ({ data: { practice } }) => {
      return practice?.subscriptions?.edges?.length > 0;
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { data } = useQuery(queryFactory);

  const subscriptionExists =
    Array.isArray(data) && data?.length === 0 ? false : data;
  const hasAccess = useAccess();

  return {
    enabled: subscriptionExists && hasAccess(["Administrator"]),
  };
}

export default useAddUserButton;
